export default __webpack_public_path__ + "static/media/filter.d019bf83.svg";